
export class GetDocStatusByRole {
  Role: string;
  DocumentStatus: string;

  docStatusByRole() {
    this.Role = localStorage.getItem("Role");
    if (this.Role === "Vendor") {
      this.DocumentStatus = "Pending Approval";
    } else if (this.Role === "PC PAR Vendor Relations" || "PC Site Admin" || "PC PAR Admin") {
      this.DocumentStatus = "Approved";
    } else {
      this.DocumentStatus = " ";
    }
    return this.DocumentStatus;
  }
}

export class GetDocStatusColor {
  approve_reject_button: boolean = false;
  css_color: string;
  // Get the status color
  getStatusColor(status, updatedBy) {
    var updatedByUser = updatedBy;
    if (status) {
      if (status.trim().toLowerCase().replace(/ /g, '') === 'approved') {
        this.approve_reject_button = false;
        this.css_color = 'Statusgreen';
      } else if (status.toLowerCase().replace(/ /g, '') === 'pendingapproval') {
        this.approve_reject_button = false;
        this.css_color = 'Statusbalck';
      } else if (status.trim().toLowerCase().replace(/ /g, '') === 'inprogress') {
        if (updatedByUser) {
          // If logged in user and lastupdated users were same then add the approve/reject button.
          if (localStorage.getItem('loginID').toLowerCase() === updatedBy.toLowerCase()) {
            this.approve_reject_button = true;
          } else {
            this.approve_reject_button = false;
          }
        } else {
          this.approve_reject_button = false;
        }
        this.css_color = 'Statusblue';
      } else if (status.trim().toLowerCase().replace(/ /g, '') === 'rejected') {
        this.approve_reject_button = false;
        this.css_color = 'Statusred';
      } else {
        this.approve_reject_button = false;
        this.css_color = 'Statusblack';
      }
    } else {
      this.approve_reject_button = false;
      this.css_color = 'Statusblack';
    }
    return ({
      'CSS' : this.css_color,
      'Approve/Reject Button' : this.approve_reject_button
    });
  }
}

export class DisableRow {
  grey: boolean = false;
  disable_edit: boolean = false;
  css_style: string;
  Role: string;

  // Greyout the row if the ststus is in inprogress
  disableRow(status, updatedBy) {
    this.Role = localStorage.getItem("Role");
    if (status) {
      var updatedByUser = updatedBy;
      if (status.trim().toLowerCase().replace(/ /g, '') === 'approved') {
        this.grey = false;
        this.disable_edit = true;
        if (this.Role !== 'Vendor')
          this.disable_edit = false;
        this.css_style = 'nochange';
      } else if (status.toLowerCase().replace(/ /g, '') === 'pendingapproval') {
        this.disable_edit = false;
        this.grey = false;
        this.css_style = 'nochange';
      } else if (status.trim().toLowerCase().replace(/ /g, '') === 'inprogress') {
        // If logged in user and lastupdated users were same then no need to greyout.
        if(updatedByUser) {
          if (localStorage.getItem('loginID').toLowerCase() === updatedByUser.toLowerCase()) {
            this.disable_edit = false;
            this.grey = false;
            this.css_style = 'nochange';
          } else {
            this.disable_edit = false;
            this.grey = true;
            this.css_style = 'inprogress';
          }
        } else {
          this.disable_edit = false;
          this.grey = true;
          this.css_style = 'inprogress';
        }
      } else if (status.trim().toLowerCase().replace(/ /g, '') === 'rejected') {
        this.grey = false;
        this.disable_edit = false;
        this.css_style = 'nochange';
      } else {
        this.grey = false;
        this.disable_edit = false;
        this.css_style = 'nochange';
      }
    } else {
      this.grey = false;
      this.disable_edit = false;
      this.css_style = 'nochenge';
    }
    return ({
      'CSS' : this.css_style,
      'Disable' : this.grey,
      'Disable_Edit': this.disable_edit
    });
  }
}



// WEBPACK FOOTER //
// ./src/shared/globalService.ts